import { render, staticRenderFns } from "./TransferReceiptVoucherListView.vue?vue&type=template&id=06811286"
import script from "./TransferReceiptVoucherListView.vue?vue&type=script&lang=js"
export * from "./TransferReceiptVoucherListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports